var Glyphicon = require("components/utility/icons/Glyphicon");

var ReactTooltip = require("react-tooltip");

require("utility/button_dropdown.scss");

class ButtonDropdown extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		if (props.inputMode) {
			this.state = { inputModeText: props.defaultText, inputModeValue: props.defaultValue }

		} else if (props.stickyOpen) {
			this.state = { open: false }
			
		} else {
			this.state = {}
		}
		
		this.wrapRef = React.createRef();
	}

	val() {
		if (this.props.inputMode) {
			return this.state.inputModeValue;
		}
	}

	reset() {
		if (this.props.inputMode) {
			this.setState({
				inputModeText: this.props.defaultText, inputModeValue: this.props.defaultValue
			});
		}
	}

	render() {
		if (this.props.icon) {
			var icon = (
				<span>
					<Glyphicon icon={ this.props.icon } />{" "}
				</span>
			);
		}

		if (this.props.dropdownDisplay == "link") {
			var buttonClass = "btn-link";
		} else {
			var buttonClass = "btn-default smallObject";
		}
		if (this.props.buttonClassName) {
			buttonClass += " " + this.props.buttonClassName;
		}

		var menuClass = "dropdown-menu scrollable-menu";
		if (this.props.rightMenu) {
			menuClass += " " + "dropdown-menu-right";
		}

		if (this.props.wide){
			menuClass += " " + "wide"
		}

		var wrapClassName = "btn-group buttonDropdown"
		if (this.props.className) {
			wrapClassName += " " + this.props.className;
		}

		if (this.props.inputMode) {
			var displayText = this.state.inputModeText;
			var originalChildren = _.isArray(this.props.children) ? this.props.children : [this.props.children];

			var children = _.map(originalChildren, function(child) {
				var clickHandler = function() {
					this.setState({ inputModeText: child.props.text, inputModeValue: child.props.value }, this.props.onChange);
				}.bind(this);
				return React.cloneElement(child, { onClick: clickHandler })
			}.bind(this));

		} else {
			var displayText = this.props.text;
			var children = this.props.children;
		}

		var wrapProps = _.omit(this.props, "children", "dropdownDisplay", "buttonClassName",
			"defaultText", "rightMenu", "icon", "text", "className", "dataTip", "inputMode", "stickyOpen");

		if (this.props.dataTip) {
			var tooltipText = this.props.dataTip;
			var toolip = (<ReactTooltip effect="solid" />);
		}

		if (this.props.useRadioButton) {
			var button = (
					<label className="normal">
						<input type="radio" />
						{ displayText }
					</label>
			)
		} else if (this.props.stickyOpen) {
			if (this.state.open) {
				wrapClassName += " open";
			}
			var button = (
				<button type="button" 
					onClick={ () => this.setState({ open: !this.state.open }) }
					className={ "btn dropdown-toggle " + buttonClass } >

					{ icon }
					{ displayText }
					<span className="caret hideOnPrint"></span>
				</button>
			)
		} else {
			var button = (
				<button type="button" className={ "btn dropdown-toggle " + buttonClass } data-toggle="dropdown">
					{ icon }
					{ displayText }
					<span className="caret hideOnPrint"></span>
				</button>
			)
		}

		return (
			<div { ...wrapProps } className={ wrapClassName }
				data-tip={ tooltipText } ref={ this.wrapRef }>
				{ button }
				<ul className={ menuClass } role="menu">
					{ children }
				</ul>
				{ toolip }
			</div>
		);
	}
	
	onDocumentClick(e) {
		var $el = $(this.wrapRef.current);
		
		if (!($el.is(e.target) || $el.has(e.target).length)) {
		 this.setState({ open: false });
		}

	}
	
	componentWillUnmount() {
		$('body').off('click', this.onDocumentClick)
	}
	
	componentDidMount() {
		$('body').on('click', this.onDocumentClick)
	}
};

ButtonDropdown.propTypes = StrictPropTypes({
	// Has the list items
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]).isRequired,

	// "Selected" text to show
	text: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
		PropTypes.number
	]),

	// Toggles formatting changes
	dropdownDisplay: PropTypes.string,
	rightMenu: PropTypes.bool,
	useRadioButton: PropTypes.bool,
	stickyOpen: PropTypes.bool,

	// Glyphicon to show next to the selected option
	icon: PropTypes.string,

	// Class to include in the wrap element
	className: PropTypes.string,

	// Class for the button itself
	buttonClassName: PropTypes.string,

	// Makes the button dropdown operating in "input mode", storing text in state, automatically
	// changing the display on option select and making the selected text available via .val()
	inputMode: PropTypes.bool,

	// Only for use when in inputMode
	defaultValue: PropTypes.string,
	defaultText: PropTypes.string,
	onChange: PropTypes.func,

	// Tooltip for label
	dataTip: PropTypes.string,

	// Passed on to outer div
	style: PropTypes.object,

	// used to make wider
	wide: PropTypes.boolean
});

module.exports = ButtonDropdown;



// WEBPACK FOOTER //
// ./modules/components/utility/ButtonDropdown.js